// For Firebase JS SDK v7.20.0 and later, measurementId is optional
module.exports = {
  apiKey: "AIzaSyChXG_hYuJGq1TmA-LJvNBvgduQFYZqsmE",
  authDomain: "selkostopanska-akademia.firebaseapp.com",
  projectId: "selkostopanska-akademia",
  storageBucket: "selkostopanska-akademia.appspot.com",
  messagingSenderId: "314989245901",
  appId: "1:314989245901:web:7ded1d3e50eb8e67da8084",
  measurementId: "G-VWTTL2BQDL"
};